import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_GUEST_USERS, GET_GUEST_USERS_ERROR, GET_GUEST_USERS_SUCCESS } from '../../actions';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* getGuestUsers({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/downloads/booking-dump-type-list`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_GUEST_USERS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_GUEST_USERS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_GUEST_USERS_ERROR, payload: error });
  }
}

export function* watchGetGuestUsers() {
  yield takeEvery(GET_GUEST_USERS, getGuestUsers);
}

function* getGuestUsersSaga() {
  yield all([fork(watchGetGuestUsers)]);
}

export default getGuestUsersSaga;
